
riot.tag2('description-tabs', '  <ul class="nav nav-tabs" if="{value.length &gt; 0}">\n    <li class="{active: activeTab === i}" each="{item, i in value}"><a onclick="{changeTab}"><span>{item.tabTitle}</span>\n        <button class="close" onclick="{closeTab}" type="button"><span> &times;</span></button></a></li>\n  </ul>\n  <div class="row" each="{item, i in value}" show="{active: activeTab === i}" no-reorder>\n    <div class="col-md-12">\n      <div class="form-inline m-t-3">\n        <div class="form-group">\n          <input class="form-control" name="tabTitle" value="{item.tabTitle}" oninput="{change}">\n        </div>\n        <div class="form-group">\n          <button class="btn btn-default" type="button" title="Добавить вкладку" onclick="{addTab}"><i class="fa fa-plus"></i></button>\n        </div>\n      </div>\n      <div class="form-group m-t-3">\n        <ckeditor name="text" value="{item.text}" onchange="{change}"></ckeditor>\n      </div>\n    </div>\n  </div>\n', '', '', function(opts) {
'use strict';

var self = this;

self.value = [];
self.activeTab = 0;

function xmlToArray(xml) {
    var matches = xml.match(/(<tab(.*?)>.*?[\s\S]*?<\/tab>)/g);

    if (matches) {
        return matches.map(function (item) {
            if (matches.length < self.activeTab) {
                self.activeTab = 0;
            }
            return {
                tabTitle: item.replace(/<tab.*?title="(.*?)".*?>.*[\s\S]*?<\/tab>/g, '$1'),
                text: item.replace(/<tab.*?>(.*[\s\S]*?)<\/tab>/g, '$1')
            };
        });
    } else {
        self.activeTab = 0;
        return [{
            tabTitle: 'Описание товара',
            text: xml
        }];
    }
}

function arrayToText(array) {
    if (array instanceof Array && array.length != 0) {
        if (array.length > 1) {
            var result = '';

            array.forEach(function (item) {
                result += '<tab title="' + item.tabTitle + '">' + item.text + '</tab>';
            });

            return result;
        } else {
            return array[0].text;
        }
    } else {
        return '';
    }
}

Object.defineProperty(self.root, 'value', {
    get: function get() {
        return arrayToText(self.value);
    },
    set: function set(value) {
        self.value = xmlToArray(value || '');
        self.update();
    }
});

self.change = function (e) {
    e.stopPropagation();
    e.stopImmediatePropagation();

    var _e$target = e.target,
        value = _e$target.value,
        name = _e$target.name;

    self.value[e.item.i][name] = value;

    var event = document.createEvent('Event');
    event.initEvent('change', true, true);
    self.root.dispatchEvent(event);
};

self.changeTab = function (e) {
    self.activeTab = e.item.i;
};

self.addTab = function (e) {
    e.stopPropagation();
    e.stopImmediatePropagation();

    self.value.push({
        tabTitle: 'Новая вкладка',
        text: ''
    });

    var event = document.createEvent('Event');
    event.initEvent('change', true, true);
    self.root.dispatchEvent(event);
};

self.closeTab = function (e) {
    e.stopPropagation();
    e.stopImmediatePropagation();
    self.value = self.value.slice(0, self.value.length);
    self.value.splice(e.item.i, 1);

    if (e.item.i <= self.activeTab) if (self.activeTab > 0) self.activeTab -= 1;

    var event = document.createEvent('Event');
    event.initEvent('change', true, true);
    self.root.dispatchEvent(event);
};

self.on('update', function () {
    if (!opts.value) self.value = [{
        tabTitle: 'Описание товара',
        text: ''
    }];

    if (opts.name) self.root.name = opts.name;
});
});


// WEBPACK FOOTER //
// ./pages/products/products/description-tabs.tag